"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Root_1 = require("../Root/Root");
var uuid = require("uuid/v4");
var css = require("./DealerViewer.scss");
var fedops_logger_1 = require("@wix/fedops-logger");
var interfaces_1 = require("../../interfaces");
var src_1 = require("@wix/dealer-store/dist/src");
var BiLogger_1 = require("@wix/dealer-common/dist/src/services/BiLogger");
var _get = require("lodash/get");
var bi_events_1 = require("@wix/dealer-common/dist/src/services/BiLogger/bi-events");
var DimensionCalculator_1 = require("@wix/dealer-common/dist/src/services/DimensionCalculator");
var i18n_1 = require("../../i18n");
var react_i18next_1 = require("react-i18next");
var viewerUrl = interfaces_1.viewerPropTypes.viewerUrl, dealerStaticViewerPropTypes = tslib_1.__rest(interfaces_1.viewerPropTypes, ["viewerUrl"]);
var DealerStaticViewerComp = /** @class */ (function (_super) {
    tslib_1.__extends(DealerStaticViewerComp, _super);
    function DealerStaticViewerComp(props) {
        var _this = _super.call(this, props) || this;
        _this.hasError = false;
        _this.getMetasiteGuid = function (props) {
            var metaSiteId = _get(props, 'dealerOptions.metaSiteId', props.metaSiteId);
            var metasiteGuid = _get(props, 'dealerOptions.metasiteGuid', props.metasiteGuid);
            return metaSiteId || metasiteGuid;
        };
        _this.log = function (eventId, additionalParams, _a) {
            if (additionalParams === void 0) { additionalParams = {}; }
            var _b = (_a === void 0 ? {} : _a).newEventStyle, newEventStyle = _b === void 0 ? true : _b;
            return _this.biLogger.log(eventId, newEventStyle, additionalParams, _this.cmsDataStore.getLocale(), _this.cmsDataStore.getMetaSiteId(), _this.cmsDataStore.getBannerRoot(), _this.cmsDataStore.getBannerPosition());
        };
        _this.onDealerError = function () {
            _this.hasError = true;
            _this.forceUpdate();
            if (_this.props.onError) {
                _this.props.onError();
            }
        };
        _this.createOnDealerView = function (onView) { return function (aboveTheFold) {
            _this.logBiView(aboveTheFold);
            if (onView) {
                onView();
            }
        }; };
        _this.logBiView = function (aboveTheFold) {
            return _this.log(bi_events_1.VIEW_EVENT, { aboveTheFold: aboveTheFold }, { newEventStyle: false });
        };
        var fedopsLogger = fedops_logger_1.create('react-dealer-viewer');
        _this.biLogger = new BiLogger_1.BiLogger(props.additionalBiParams);
        var data = {
            bannerPosition: _this.props.bannerPosition,
            locale: _this.props.locale,
            metasiteGuid: _this.getMetasiteGuid(_this.props),
            onClick: _this.props.onClick,
            onDisplay: _this.props.onDisplay,
            onEmpty: _this.props.onEmpty,
            onView: _this.props.onView,
            onError: _this.props.onError,
            translationsUrl: _this.props.translationsUrl,
            fedopsLogger: fedopsLogger,
            banners: tslib_1.__assign({}, _this.props.banner, { bannerTemplate: JSON.parse(_this.props.banner.bannerTemplate) }),
            biLogger: _this.biLogger,
        };
        _this.cmsDataStore = new src_1.CmsDataStore(data);
        _this.requestGuid = uuid();
        _this.log(bi_events_1.BANNER_INIT, { requestGuid: _this.requestGuid }, { newEventStyle: true });
        return _this;
    }
    DealerStaticViewerComp.prototype.componentDidMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.log(bi_events_1.BANNER_RENDERED, { requestGuid: this.requestGuid }, { newEventStyle: true });
                this.props.onDisplay &&
                    this.props.onDisplay({
                        isDisplayed: this.cmsDataStore.shouldShowBanner(),
                        bannerLocationOnPage: this.cmsDataStore.getBannerLocation(),
                        width: DimensionCalculator_1.calculateWidth(this.cmsDataStore.pageSettings, this.cmsDataStore.getContext()),
                        height: DimensionCalculator_1.calculateHeight(this.cmsDataStore.pageSettings, this.cmsDataStore.getContext()),
                    });
                return [2 /*return*/];
            });
        });
    };
    DealerStaticViewerComp.prototype.render = function () {
        var onDealerView = this.createOnDealerView(this.cmsDataStore.getOnView());
        return this.hasError ? (React.createElement("span", { className: css.failedContainer })) : (React.createElement("span", { className: css.dealerViewer },
            React.createElement(Root_1.Root, { dealerOptions: this.props.dealerOptions, cmsDataStore: this.cmsDataStore, loaded: true, onView: onDealerView, onError: this.onDealerError })));
    };
    DealerStaticViewerComp.propTypes = tslib_1.__assign({}, dealerStaticViewerPropTypes);
    DealerStaticViewerComp.defaultProps = tslib_1.__assign({}, interfaces_1.viewerDefaultProps);
    return DealerStaticViewerComp;
}(React.Component));
exports.DealerStaticViewerComp = DealerStaticViewerComp;
var DealerStaticViewer = /** @class */ (function (_super) {
    tslib_1.__extends(DealerStaticViewer, _super);
    function DealerStaticViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DealerStaticViewer.getI18n = function (locale, translationsUrl) {
        if (DealerStaticViewer.i18n === undefined) {
            DealerStaticViewer.i18n = i18n_1.default({ locale: locale, baseUrl: translationsUrl });
        }
        return DealerStaticViewer.i18n;
    };
    DealerStaticViewer.prototype.render = function () {
        return (React.createElement(react_i18next_1.I18nextProvider, { i18n: DealerStaticViewer.getI18n(this.props.locale, this.props.translationsUrl) },
            React.createElement(DealerStaticViewerComp, tslib_1.__assign({}, this.props))));
    };
    return DealerStaticViewer;
}(React.Component));
exports.DealerStaticViewer = DealerStaticViewer;
//# sourceMappingURL=DealerStaticViewer.js.map